import { SubscriptionManager } from "./subscriptionManager";
/**
 * Specialized type of subscription manager that notifies on CRUD-style events.  Designed to be a low-impedance
 * match for repositories.
 */
export class StorageSubscriptionManager extends SubscriptionManager {
}
//# sourceMappingURL=storageSubscriptionManager.js.map